import CashflowDataUtil from '../helpers/CashflowDataUtil'
import loan from './testData/loan'

describe('CashflowDataUtil', () => {
  describe('getSource', () => {
    it('should find the source for the given year and an array of cashflow data', () => {
      const expectedSources = Object.freeze({
        2014: 'manual_document',
        2015: 'manual_document',
        2016: 'manual_transcript',
        2017: 'manual_document',
        2018: 'manual_document'
      })
      const cashflowData = Object.freeze(loan.businesses[0].cashflowData)
      for (const year in expectedSources) {
        const source = CashflowDataUtil.getSource(cashflowData, parseInt(year))
        expect(source).toEqual(expectedSources[year])
      }
    })
  })
})
